import PropTypes from 'prop-types';

export const TableDefaultProps = {
  addToCartOptions: null,
  brand: {},
  className: null,
  companyAvailability: false,
  configurationsSortables: {},
  customerPrice: null,
  hasPrice: true,
  disabled: false,
  discountPrice: null,
  hasStock: true,
  id: null,
  image: {},
  invoiceUnit: null,
  isFavorite: false,
  isLoading: false,
  mainSku: null,
  manufacturerSku: null,
  name: null,
  path: null,
  publicPrice: null,
  saleUnit: null,
  salesPackaging: null,
  sku: null,
  slug: null,
  sortables: {},
  splitPackaging: false,
  stockStatus: null,
  stocks: [],
  weeeAmount: null,
};

export const TablePropTypes = {
  addToCartOptions: PropTypes.shape({
    dataLayer: PropTypes.shape({
      event: PropTypes.string,
    }),
    flashMessage: PropTypes.bool,
    link: PropTypes.bool,
    linkUrl: PropTypes.string,
    messages: PropTypes.shape({
      link: PropTypes.string,
      text: PropTypes.string,
      title: PropTypes.string,
      undo: PropTypes.string,
    }),
    modal: PropTypes.bool,
    predictions: PropTypes.bool,
    undo: PropTypes.bool,
  }),
  brand: PropTypes.shape({ logo: PropTypes.shape({}), name: PropTypes.string }),
  className: PropTypes.string,
  companyAvailability: PropTypes.bool,
  configurationsSortables: PropTypes.shape({
    [PropTypes.string]: PropTypes.shape({
      code: PropTypes.string,
      displayable: PropTypes.bool,
      filterable: PropTypes.bool,
      label: PropTypes.string,
      order: PropTypes.number,
      searchable: PropTypes.bool,
      sortable: PropTypes.bool,
      unit: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    }),
  }),
  customerPrice: PropTypes.number,
  disabled: PropTypes.bool,
  discountPrice: PropTypes.number,
  hasPrice: PropTypes.bool,
  hasStock: PropTypes.bool,
  id: PropTypes.string,
  image: PropTypes.shape({}),
  invoiceUnit: PropTypes.string,
  isFavorite: PropTypes.bool,
  isLoading: PropTypes.bool,
  mainSku: PropTypes.string,
  manufacturerSku: PropTypes.string,
  name: PropTypes.string,
  path: PropTypes.string,
  publicPrice: PropTypes.number,
  saleUnit: PropTypes.string,
  salesPackaging: PropTypes.number,
  sku: PropTypes.string,
  slug: PropTypes.string,
  sortables: PropTypes.oneOfType([
    PropTypes.shape({
      [PropTypes.string]: PropTypes.shape({
        code: PropTypes.string,
        displayable: PropTypes.bool,
        filterable: PropTypes.bool,
        label: PropTypes.string,
        order: PropTypes.number,
        searchable: PropTypes.bool,
        sortable: PropTypes.bool,
        unit: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      }),
    }),
    PropTypes.arrayOf(PropTypes.shape({})),
  ]),
  splitPackaging: PropTypes.bool,
  stockStatus: PropTypes.string,
  stocks: PropTypes.arrayOf(PropTypes.shape({})),
  weeeAmount: PropTypes.number,
};
